import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import smartcity_logo from '../assets/logo.svg';

import "./Header.css";

const Header = ({isAuthenticated, onLogout = () => {}}) => {
  return (
    <AppBar position="static">
      <Toolbar style={{ backgroundColor: 'white' }}>
        <img 
          src={smartcity_logo} 
          alt="Logo" 
          style={{ width: '80px', height: '80px', marginRight: '16px' }}
        />
        <Typography variant="h6" sx={{ flexGrow: 1 }} color="primary">
          Reports
        </Typography>
        {isAuthenticated && <Button color="primary" onClick={onLogout}>Logout</Button>}
      </Toolbar>
    </AppBar>
  );
};

export default Header;